import { render, staticRenderFns } from "./Fondeo.vue?vue&type=template&id=6bf6751c&scoped=true"
import script from "./Fondeo.vue?vue&type=script&lang=js"
export * from "./Fondeo.vue?vue&type=script&lang=js"
import style0 from "./Fondeo.vue?vue&type=style&index=0&id=6bf6751c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf6751c",
  null
  
)

export default component.exports